import {
  NS_GET_INVEST_DETAIL_DATA,
  NS_GET_INVEST_DETAIL_DATA_SUCCESS,
  NS_GET_INVEST_DETAIL_DATA_FAIL,
  NS_GET_INVEST_DETAIL_HIT_DATA,
  NS_GET_INVEST_DETAIL_HIT_DATA_SUCCESS,
  NS_GET_INVEST_DETAIL_HIT_DATA_FAIL,
  NS_GET_INVEST_DETAIL_PASTHITS_DATA,
  NS_GET_INVEST_DETAIL_PASTHITS_DATA_SUCCESS,
  NS_GET_INVEST_DETAIL_PASTHITS_DATA_FAIL,
  NS_RESET_INVEST_DETAIL_DATA,
  NS_RESET_INVEST_DETAIL_PASTHITS_DATA
} from '../../actions/ns/investigationDetail';
import { RESET_INVESTIGATION_DETAIL_DATA } from '../../actions/tm/investigationDetail';

export const initialState = {
  alertDetail: {
    isLoading: false,
    data: null,
    error: null
  }
};

function nsInvestigationDetail(state = initialState, action) {
  switch (action.type) {
    case NS_GET_INVEST_DETAIL_HIT_DATA:
      return {
        ...state,
        alertDetail: {
          ...state.alertDetail,
          isLoading: true
        }
      };
    case NS_GET_INVEST_DETAIL_HIT_DATA_SUCCESS:
      return {
        ...state,
        alertDetail: {
          isLoading: false,
          data: {
            ...state.alertDetail.data,
            hits: action.payload.list,
            totalCount: action.payload.totalCount
          },
          error: null
        }
      };
    case NS_GET_INVEST_DETAIL_HIT_DATA_FAIL:
      return {
        ...state,
        alertDetail: {
          isLoading: false,
          data: {
            ...state.alertDetail.data,
            hits: [],
            totalCount: 0
          },
          error: action.payload
        }
      };

    case NS_GET_INVEST_DETAIL_DATA:
      return {
        ...state,
        alertDetail: {
          isLoading: true,
          data: null,
          error: null
        }
      };
    case NS_GET_INVEST_DETAIL_DATA_SUCCESS:
      return {
        ...state,
        alertDetail: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_GET_INVEST_DETAIL_DATA_FAIL:
      return {
        ...state,
        alertDetail: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case NS_GET_INVEST_DETAIL_PASTHITS_DATA:
      return {
        ...state,
        pastHitsData: {
          isLoading: true,
          data: []
        }
      };
    case NS_GET_INVEST_DETAIL_PASTHITS_DATA_SUCCESS:
      return {
        ...state,
        pastHitsData: {
          isLoading: false,
          data: action.payload
        }
      };
    case NS_GET_INVEST_DETAIL_PASTHITS_DATA_FAIL:
      return {
        ...state,
        pastHitsData: {
          isLoading: true,
          data: []
        }
      };

    case RESET_INVESTIGATION_DETAIL_DATA:
      return initialState;
    default:
      return {
        ...state
      };
  }
}

export default nsInvestigationDetail;
